import L from 'leaflet';

const generateIcon = (iconFile: string, iconRetinaFile: string):L.Icon => {
  return new L.Icon({
   iconUrl:  `assets/images/${iconFile}`,
   iconRetinaUrl: `assets/images/${iconRetinaFile}`,
   shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
   iconSize: [18, 29],
   iconAnchor: [12, 29],
   popupAnchor: [1, -34],
   shadowSize: [29, 29]
 }); 
}
export const blueIcon = generateIcon('marker-icon-2x-blue.png','marker-icon-blue.png');
export const goldIcon = generateIcon('marker-icon-2x-gold.png','marker-icon-gold.png');
export const orangeIcon = generateIcon('marker-icon-2x-orange.png','marker-icon-orange.png');
export const redIcon = generateIcon('marker-icon-2x-red.png','marker-icon-red.png');
export const violetIcon = generateIcon('marker-icon-2x-violet.png','marker-icon-violet.png');
export const greenIcon = generateIcon('marker-icon-2x-green.png','marker-icon-green.png');
